import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, Paperclip } from "lucide-react";
import { Button } from "../ui/button";
import { fileUrl } from "../../lib/api";
import { rcApi, errMsg, fmt } from "./rcApi";

export const RiderCashDeposits = ({ onChanged }) => {
  const [rows, setRows] = useState([]);
  const [method, setMethod] = useState({});
  const load = useCallback(() => rcApi.txns({ status: "pending" }).then(setRows).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const act = async (t, ok) => {
    try {
      if (ok) await rcApi.confirm(t.id, method[t.id] || "bank");
      else { const r = window.prompt("سبب الرفض (اختياري)"); if (r === null) return; await rcApi.reject(t.id, r); }
      toast.success(ok ? "تم تأكيد التوريد" : "تم الرفض"); load(); onChanged();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows.length) return <p className="rounded-xl border border-dashed p-10 text-center text-sm text-slate-400" data-testid="rc-deposits-empty">لا توجد إيصالات توريد بانتظار التأكيد</p>;
  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid="rc-deposits-list">
      {rows.map((t) => (
        <div key={t.id} className="rounded-xl border bg-white p-4" data-testid={`rc-deposit-${t.id}`}>
          <div className="flex items-start justify-between">
            <div><p className="font-semibold">{t.employee_name}</p><p className="text-xs text-slate-500">{t.date} · {t.note || "بدون ملاحظة"}</p></div>
            <p className="text-lg font-bold tabular-nums text-emerald-600">{fmt(t.amount)}</p>
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            {t.file_id && <a className="flex items-center gap-1 text-xs text-blue-600" href={fileUrl(t.file_id)} target="_blank" rel="noreferrer" data-testid={`rc-deposit-file-${t.id}`}><Paperclip className="h-3.5 w-3.5" />الإيصال</a>}
            <select data-testid={`rc-deposit-method-${t.id}`} className="rounded border px-2 py-1 text-xs" value={method[t.id] || "bank"} onChange={(e) => setMethod({ ...method, [t.id]: e.target.value })}>
              <option value="bank">إيداع بنكي</option><option value="cash">استلام نقدي</option>
            </select>
            <Button size="sm" className="mr-auto bg-emerald-600 hover:bg-emerald-700" data-testid={`rc-deposit-confirm-${t.id}`} onClick={() => act(t, true)}><Check className="h-4 w-4" />تأكيد</Button>
            <Button size="sm" variant="outline" className="text-rose-600" data-testid={`rc-deposit-reject-${t.id}`} onClick={() => act(t, false)}><X className="h-4 w-4" />رفض</Button>
          </div>
        </div>
      ))}
    </div>
  );
};
